import * as React from 'react';
import { Route } from '../../side-drawer.component';
import { NavItem } from '../nav-item/nav-item';
import * as classes from './nav-box.scss';

const renderNavItems = (props: any) => {
  return props.routes.map((route: Route) => (
    <NavItem
      key={route.name}
      route={route}
      small={true}
      show={props.show}
      toggleActiveChild={props.toggleActiveChild}
      toggleSidebar={props.toggleSidebar}
    />
  ));
};

export const NavBox = (props: any) => (
  <ol className={props.show ? [classes.navBox, classes.visible].join(' ') : classes.navBox}>{renderNavItems(props)}</ol>
);



// WEBPACK FOOTER //
// ./src/side-drawer/_components/nav-box/nav-box.tsx